import { userRoleEmailId } from "helpers/string";
import { MessageTemplate } from "./models";
import { MessageTemplateSchema } from "./schema";
import { CreateMessageTemplatePayload, UpdateMessageTemplatePayload } from "./models/payloads";
import { TemplateMeetingAttendee } from "../MeetingTemplate/models";

export function messageTemplatePrimaryTrigger(template: MessageTemplate) {
  return template?.deliverAtTrigger;
}

export function templateAttendeeToUserRoleOrEmailId(meetingAttendee: TemplateMeetingAttendee) {
  return userRoleEmailId(meetingAttendee?.emailAddress, meetingAttendee?.attendeeType, meetingAttendee?.attendeeId, meetingAttendee?.emailType);
}

/**
 * Transform API response data to form data
 * No conversion needed for triggers - they use the same format now
 *
 * @param data - MessageTemplate from API response
 * @returns MessageTemplateSchema ready for form initialization
 */
export function toMessageTemplateFormData(data: MessageTemplate): MessageTemplateSchema {
  const {
    deliverAtTrigger,
    paths = [],
    ...rest
  } = data;

  return {
    ...rest,
    deliverAtTrigger,
    paths,
    allowWeekends: false,
  };
}

/**
 * Transform form data to API create payload
 * Removes form-only fields and ensures correct structure for API
 */
export function toCreateMessageTemplatePayload(formData: MessageTemplateSchema): CreateMessageTemplatePayload {

  const { paths, ...rest } = formData;

  // Type assertion needed because form trigger types differ from API trigger types
  return rest as CreateMessageTemplatePayload;
}

/**
 * Transform form data to API update payload
 * Same as create but all fields optional
 */
export function toUpdateMessageTemplatePayload(formData: Partial<MessageTemplateSchema>): UpdateMessageTemplatePayload {

  const { paths, ...rest } = formData;

  return rest as UpdateMessageTemplatePayload;
}
